<prlw-mobile-overlay-card-ui
  *ngIf="item"
  [maxHeight]="82"
  [showXButton]="false"
  (eventClickX)="eventClose.emit()"
  class="basis-details-mobile"
>
  <div header class="top-part">
    <svg
      (click)="eventClose.emit()"
      class="x"
      width="37"
      height="37"
      viewBox="0 0 37 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 18.5C0 8.28273 8.28273 0 18.5 0C28.7173 0 37 8.28273 37 18.5C37 28.7173 28.7173 37 18.5 37C8.28273 37 0 28.7173 0 18.5Z"
        fill="#F5F5F5"
      />
      <path d="M13 13L24 24" stroke="black" stroke-width="1.5" />
      <path d="M24 13L13 24" stroke="black" stroke-width="1.5" />
    </svg>

    <div class="basis-code-container">
      {{ item.shipment.code
      }}<prlw-text-tag-otp
        [instrumentCode]="item.instrumentCode"
        size="medium"
      ></prlw-text-tag-otp>
      <svg
        width="28"
        height="22"
        viewBox="0 0 28 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        (click)="eventClickAboutBasis.emit()"
      >
        <rect
          x="7"
          y="4"
          width="14"
          height="14"
          rx="7"
          stroke="black"
          stroke-width="2"
        />
        <rect x="13" y="9.5" width="2" height="6" rx="1" fill="black" />
        <rect x="13" y="6.5" width="2" height="2" rx="1" fill="black" />
      </svg>
    </div>
  </div>
  <div body>
    <ng-content select="[body]"></ng-content>
    <prlw-basis-details-ui [instrument]="item"></prlw-basis-details-ui>
  </div>
</prlw-mobile-overlay-card-ui>
